import { BaseEntity } from "yt-ng-framework";

export class FirmaZrc extends BaseEntity{
    constructor(){
        super();
    }

    FirmaID: number = null;
    Zrc1:string = null;
    Zrc2:string = null;
    Zrc3:string = null;
    Zrc:string = null;
    Glavni:boolean = null;
    Devizni:boolean = null;
    BankaID:number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.FirmaID = input.FirmaID;
        this.Zrc1=input.Zrc1;
        this.Zrc2=input.Zrc2;
        this.Zrc3=input.Zrc3;
        this.Zrc = this.Zrc1 +'-'+ this.Zrc2 +'-'+ this.Zrc3;
        this.Glavni=input.Glavni;
        this.Devizni=input.Devizni;
        this.BankaID=input.BankaID;
        return this;
    }

    Serialize(input:FirmaZrc){
        input.Zrc=input.Zrc.replace(/-/g,"");
        input.Zrc1=input.Zrc.substr(0,3).trim();
        input.Zrc2=input.Zrc.substr(3,input.Zrc.length-5).trim();
        input.Zrc3=input.Zrc.substr(input.Zrc.length-2,2).trim();
        return input;
    }
}